module.exports = __webpack_public_path__ + "static/media/payment_wallet_icon_active.e29e83fb.svg";